import { isRejectedWithValue, isFulfilled } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import i18next from 'i18next'
// import * as R from 'ramda'

const doNotWarn404 = (payload, meta) => {
  return (
    (payload.statusCode === 404 &&
      meta.arg?.endpointName === 'miniVprConfiguration') ||
    (payload.statusCode === 404 && meta.arg?.endpointName === 'rtmTrip')
  )
}

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorNotifier = () => (next) => (action) => {
  const { error, payload, meta, type } = action
  if (isFulfilled(action) && payload?.statusCode > 300) {
    console.warn('We got an bapi error!', action)
    // Do not automatically notify mutation errors.
    // Each mutation error is handled in place.
    // Notify GET errors instead, because GETs are
    // not managed directly
    if (!/executeMutation/.test(type) && !doNotWarn404(payload, meta)) {
      toast.warn(
        i18next.t('common:errors.ApiErrorMessage', {
          status: payload.statusCode,
          message: payload.message || payload.data?.humanReadableMessage || 'Not specified',
          endpoint: meta.arg.endpointName,
        }),
      )
    }
  } else if (isRejectedWithValue(action)) {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
    console.warn('We got an fapi error!', action)
    // Do not automatically notify mutation errors.
    // Each mutation error is handled in place.
    // Notify GET errors instead, because GETs are
    // not managed directly
    if (!/executeMutation/.test(type)) {
      toast.warn(
        i18next.t('common:errors.ApiErrorMessage', {
          status: payload.originalStatus || payload.status,
          message: error.message,
          endpoint: meta.arg.endpointName,
        }),
      )
    }
  }

  return next(action)
}
